import React from 'react'
import { connect } from 'react-redux';
import _ from 'lodash';
import color from '../../res/color';
import tono1a from '../../res/img/TonoDaruma_01A.gif';
import tono1c from '../../res/img/TonoDaruma_01C.gif';
import tono2a from '../../res/img/TonoDaruma_02A.gif';
import tono6b from '../../res/img/TonoDaruma_06B.gif';
import tono6a from '../../res/img/TonoDaruma_06A.gif';
import tono7a from '../../res/img/TonoDaruma_07A.gif';
import reloadIcon from '../../res/img/reload.png';
import faqIcon from '../../res/img/faq.png';
// import './css/result.css';
import ShareIcons from './compornents/shareIcons';
import ResultCommentTitle from './compornents/resultContentTitle';
import volumeText from '../../res/text/volumeText';
import speechText from '../../res/text/speechText';
import emoText from '../../res/text/emoText';
import comprehensiveText from '../../res/text/comprehensiveText';
import proverbText from '../../res/text/proverbText';
import stylesPc from './styles/resultPageStyle'
import stylesPhone from './styles/resultPageStyleSmartPhone.js'

var styles;

type Props = {
    calm: Array;
    anger: Array;
    joy: Array;
    sorrow: Array;
    volArray: Array;
};

type State = {
    speechProportion: Number;
    volumeLevel: Number;
    emoAverage: Number;
    emoRank: Number;
    volRank: Number;
    speechRank: Number;
};

class ResultPage extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.containerDiv = React.createRef();
        this.state = {
            emoAverage: 0,
            speechProportion: 0,
            volumeLevel: 0,
            emoRank: 0,
            volRank: 0,
            speechRank: 0,
        }
    }

    componentWillMount() {
        this.getEmoAverage();
        this.getVolumeLevel();
        this.getSpeechProportion();
        this.getEmoRank();
        this.getSpeechProportionRank();
        this.getVolumeRank();
        this.getComprehensiveRank();
    }

    //活性度
    getEmoAverage(): Function {
        var angerAve = _.sum(this.props.anger) / this.props.anger.length;
        var joyAve = _.sum(this.props.joy) / this.props.joy.length;
        var ave = (angerAve + joyAve) * 2;
        var val = ave > 0 ? _.ceil(ave, 0) : 0;
        this.setState({
            emoAverage: val,
        });
        return val;
    }

    getEmoRank(): Function {
        var level = this.getEmoAverage();
        var rank;
        if (level <= 21) {
            rank = 1;
        } else if (level <= 41) {
            rank = 3;
        } else if (level <= 61) {
            rank = 4;
        } else if (level <= 81) {
            rank = 5;
        } else {
            rank = 2;
        }
        this.setState({
            emoRank: rank,
        })
    }

    getEmoRankTextMain(): Function {
        var textArray = emoText.main[this.state.emoRank];
        return textArray[_.random(0, textArray.length - 1)]
    }

    getEmoRankTextTitle(): Function {
        var textArray = emoText.title[this.state.emoRank];
        return textArray[_.random(0, textArray.length - 1)]
    }

    getEmoRankTextComment(): Function {
        var textArray = emoText.comment[this.state.emoRank];
        return textArray[_.random(0, textArray.length - 1)]
    }

    //発話量
    getSpeechProportion(): Function {
        var totalVolCount = this.props.volArray.length;
        var speechSec = totalVolCount / 23;
        var percent = _.ceil((speechSec / this.props.meetingTime) * 100, 0);
        if (isNaN(percent)) return 0;
        var val = Number.isFinite(percent) ? percent : 0;
        val = val > 100 ? 100 : val;
        val = val < 0 ? 0 : val;
        this.setState({
            speechProportion: val,
        });
        return val;
    }

    getSpeechProportionRank(): Function {
        var level = this.getSpeechProportion();
        var rank;
        if (level <= 10) {
            rank = 1;
        } else if (level <= 20) {
            rank = 3;
        } else if (level <= 35) {
            rank = 4;
        } else if (level <= 40) {
            rank = 5;
        } else {
            rank = 2;
        }
        this.setState({
            speechRank: rank,
        })
    }

    getSpeechProportionRankTextMain(): Function {
        var textArray = speechText.main[this.state.speechRank];
        return textArray[_.random(0, textArray.length - 1)]
    }

    getSpeechProportionRankTextTitle(): Function {
        var textArray = speechText.title[this.state.speechRank];
        return textArray[_.random(0, textArray.length - 1)]
    }

    getSpeechProportionRankTextComment(): Function {
        var textArray = speechText.comment[this.state.speechRank];
        return textArray[_.random(0, textArray.length - 1)]
    }

    //音量
    getVolumeLevel(): Function {
        var sum = _.sum(this.props.volArray);
        var ave = sum / this.props.volArray.length;
        if (isNaN(ave)) return 0;
        var val = ave > 100 ? 100 : _.ceil(ave, 0);
        this.setState({
            volumeLevel: val,
        });
        return val;
    }

    getVolumeRank(): Function {
        var level = this.getVolumeLevel();
        var rank;
        if (level <= 20) {
            rank = 1;
        } else if (level <= 50) {
            rank = 3;
        } else if (level <= 70) {
            rank = 4;
        } else if (level <= 90) {
            rank = 5;
        } else {
            rank = 2;
        }
        this.setState({
            volRank: rank,
        })
    }

    getVolumeRankTextMain(): Function {
        var textArray = volumeText.main[this.state.volRank];
        return textArray[_.random(0, textArray.length - 1)]
    }

    getVolumeRankTextTitle(): Function {
        var textArray = volumeText.title[this.state.volRank];
        return textArray[_.random(0, textArray.length - 1)]
    }

    getVolumeRankTextComment(): Function {
        var textArray = volumeText.comment[this.state.volRank];
        return textArray[_.random(0, textArray.length - 1)]
    }

    //総合評価
    getComprehensiveRank(): Function {
        var total = this.state.emoRank + this.state.volRank + this.state.speechRank;
        var rank;
        if (total <= 5) {
            rank = 1;
        } else if (total <= 8) {
            rank = 2;
        } else if (total <= 11) {
            rank = 3;
        } else if (total <= 13) {
            rank = 4;
        } else {
            rank = 5;
        }
        return rank;
    }

    getComprehensiveText(): Function {
        var textArray = comprehensiveText.main[this.getComprehensiveRank()];
        if (textArray === undefined || textArray.length <= 0) {
            return "";
        }
        return textArray[_.random(0, textArray.length - 1)]
    }

    getComprehensiveTitle(): Function {
        var textArray = comprehensiveText.title[this.getComprehensiveRank()];
        if (textArray === undefined || textArray.length <= 0) {
            return "";
        }
        return textArray[_.random(0, textArray.length - 1)]
    }

    getTonoImage(): Function {
        switch (this.getComprehensiveRank()) {
            case 1:
                return tono6a;
            case 2:
                return tono2a;
            case 3:
                return tono7a;
            case 4:
                return tono6b;
            case 5:
                return tono1c;
            default:
                return tono1a;
        }
    }

    //格言
    getProverbText() {
        var textArray = proverbText.proverb;
        return textArray[_.random(0, textArray.length - 1)];
    }

    getShareText(): Function {
        var emo = "活性度:" + this.state.emoAverage + "% " + this.getEmoRankTextTitle();
        var speech = "発話量:" + this.state.speechProportion + "% " + this.getSpeechProportionRankTextTitle();
        var volume = "声量:" + this.state.volumeLevel + "% " + this.getVolumeRankTextTitle();
        return "あなたの発言の診断結果は...\n"
            + emo + "\n"
            + speech + "\n"
            + volume + "\n";
    }

    render() {
        styles = this.props.screenwidth > 400 * 2 ? stylesPc : stylesPhone;
        return (
            <div style={styles.main}>
                <div style={styles.leftFrame} class="left">
                    <p style={styles.title}>診断結果</p>
                    <div style={styles.tonoImages}>
                        <p style={styles.tonoComment}>{this.getComprehensiveTitle()}</p>
                        <img style={styles.tono} src={this.getTonoImage()} alt="tono" />
                    </div>
                    <div style={styles.commentBox}>
                        <div style={styles.commentFrame}>
                            <p style={styles.comment}></p>
                            <p style={styles.comment}>トノさんは、このようにのたまっています……</p>
                            <p style={styles.comment}>{this.getVolumeRankTextMain() + this.getSpeechProportionRankTextMain() + this.getEmoRankTextMain()}</p>
                            <p style={styles.commentBold}>{this.getComprehensiveText()}</p>
                            <p style={styles.comment}>そんなあなたにこの格言</p>
                            <p style={styles.commentItalic}>{this.getProverbText()}</p>
                        </div>
                        <ResultCommentTitle title="フィードバック" bgColor={color.empathGreen} />
                    </div>
                </div>

                <div style={styles.rightFrame}>
                    <p style={styles.evaluationTitle}>評価項目</p>
                    <div style={styles.resultFrame} class="result">
                        <ResultCommentTitle title="活性度" bgColor={color.empathPink} />
                        <div style={styles.resultContent}>
                            <div style={styles.resultLeft}>
                                <div style={Object.assign({}, ...[styles.resultCircleOut, {
                                    background: color.empathPink,
                                    marginTop: 35,
                                    marginBottom: 35,
                                }])}>
                                    <div style={styles.resultCircle}>
                                        <div style={styles.resultValue}>{this.state.emoAverage}</div>
                                        <div style={styles.resultExtention}>%</div>
                                    </div>
                                </div>
                            </div>
                            <div style={styles.resultRight}>
                                <p style={styles.resultCommentTitle}>{this.getEmoRankTextTitle()}</p>
                                <p style={styles.resultComment}>{this.getEmoRankTextComment()}</p>
                            </div>
                        </div>
                    </div>

                    <div style={styles.resultFrame} class="result">
                        <ResultCommentTitle title="発話量" bgColor={color.empathYellow} />
                        <div style={styles.resultContent}>
                            <div style={styles.resultLeft}>
                                <div style={Object.assign({}, ...[styles.resultCircleOut, {
                                    background: color.empathYellow,
                                    marginTop: 35,
                                    marginBottom: 35,
                                }])}>
                                    <div style={styles.resultCircle}>
                                        <div style={styles.resultValue}>{this.state.speechProportion}</div>
                                        <div style={styles.resultExtention}>%</div>
                                    </div>
                                </div>
                            </div>
                            <div style={styles.resultRight}>
                                <p style={styles.resultCommentTitle}>{this.getSpeechProportionRankTextTitle()}</p>
                                <p style={styles.resultComment}>{this.getSpeechProportionRankTextComment()}</p>
                            </div>
                        </div>
                    </div>

                    <div style={styles.resultFrame} class="result">
                        <ResultCommentTitle title="声量" bgColor={color.empathBlue} />
                        <div style={styles.resultContent}>
                            <div style={styles.resultLeft}>
                                <div style={Object.assign({}, ...[styles.resultCircleOut, {
                                    background: color.empathBlue,
                                    marginTop: 35,
                                    marginBottom: 15,
                                }])}>
                                    <div style={styles.resultCircle}>
                                        <div style={styles.resultValue}>{this.state.volumeLevel}</div>
                                        <div style={styles.resultExtention}>%</div>
                                    </div>
                                </div>
                            </div>
                            <div style={styles.resultRight}>
                                <p style={styles.resultCommentTitle}>{this.getVolumeRankTextTitle()}</p>
                                <p style={styles.resultComment}>{this.getVolumeRankTextComment()}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={styles.reloadFrame} >
                    <img style={styles.reloadIcon} src={reloadIcon} alt="reload" />
                    <p style={{ cursor: 'pointer', }} onClick={() => window.location.reload()}>もう一度やる</p>
                </div>
                <div style={styles.faqFrame}>
                    <img style={styles.faqIcon} src={faqIcon} alt="faq" />
                    <a style={styles.link} href="https://webempath.com/jpn/contact/" target="_blank" rel="noopener noreferrer">お問い合わせ</a>
                </div>
                <ShareIcons result={this.getShareText()} />
            </div>
        );
    }
}

ResultPage.defaultProps = {
    calm: [],
    anger: [],
    joy: [],
    sorrow: [],
    meetingTime: 0,
    volArray: [],
}

const mapStateToProps = state => ({
    screenwidth: state.app.screenWidth,
});

export default connect(mapStateToProps)(ResultPage);